<template>
    <div class="ledger-page">
        <div class="head">
            <span class="title">כרטסת</span>
            <span class="supplier-name">{{ supplier.selectDealerName }}</span>
        </div>
  
      <div class="ledger-controls">
        <!-- فلاتر التاريخ والبحث لاحقًا -->
      </div>
  
      <table class="ledger-table">
        <thead>
          <tr>
            <th>التاريخ</th>
            <th>النوع</th>
            <th>الوصف</th>
            <th>الكمية</th>
            <th>السعر</th>
            <th>المبلغ</th>
            <th>طريقة الدفع</th>
            <th>مرفق</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tx in transactions" :key="tx.id">
            <td>{{ formatDate(tx.date) }}</td>
            <td>{{ tx.type }}</td>
            <td>{{ tx.description }}</td>
            <td>{{ tx.quantity || '-' }}</td>
            <td>{{ tx.unitPrice || '-' }}</td>
            <td>{{ tx.totalAmount }}</td>
            <td>{{ tx.paymentMethod }}</td>
            <td>
              <a v-if="tx.attachmentURL" :href="tx.attachmentURL" target="_blank">📎</a>
            </td>
          </tr>
        </tbody>
      </table>
  
      <div class="ledger-summary">
        <p>📌 مجموع المشتريات: ₪ {{ totalPurchases }}</p>
        <p>💸 مجموع الدفعات: ₪ {{ totalPayments }}</p>
        <p>📊 الرصيد النهائي: ₪ {{ balance }}</p>
      </div>
    </div>
  </template>
  <script>
  import firebase from 'firebase/app'
  import 'firebase/firestore'
  
  export default {
    data() {
      return {
        supplier: {},
        transactions: [],
        totalPurchases: 0,
        totalPayments: 0,
        balance: 0,
        supplierId: this.$route.params.id,

      }
    },
    async created() {
        const supplierId = this.$route.params.id;
        this.supplierId = supplierId;
        console.log(this.supplier)
      await this.fetchSupplier()
      await this.listenToTransactions()
      this.calculateTotals()
    },
    watch: {
        '$route.params.id'(newId, oldId) {
            // console.log('🔄 تغير المورد من', oldId, 'إلى', newId);
            this.supplierId = newId;
            this.fetchSupplier();
            this.listenToTransactions(); // أو fetchTransactions حسب طريقتك
        }
    },
    methods: {
      async fetchSupplier() {
        const doc = await firebase.firestore().collection('Dealers').doc(this.supplierId).get()
        this.supplier = { id: doc.id, ...doc.data() }
      },
    listenToTransactions() {
        firebase.firestore()
        .collection('Dealers')
        .doc(this.supplierId)
        .collection('transactions')
        .orderBy('date', 'desc')
        .onSnapshot(snapshot => {
            this.transactions = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            this.calculateTotals()
        })
    },
    calculateTotals() {
        this.totalPurchases = this.transactions
        .filter(t => t.type === 'purchase')
        .reduce((sum, t) => sum + (t.totalAmount || 0), 0)

        this.totalPayments = this.transactions
        .filter(t => t.type === 'payment')
        .reduce((sum, t) => sum + (t.totalAmount || 0), 0)

        this.balance = this.totalPurchases - this.totalPayments
    },
      formatDate(ts) {
        if (!ts) return ''
        const date = ts.toDate()
        return date.toLocaleDateString()
      }
    }
  }
  </script>
  <style scoped >
  .ledger-page{
    padding: 1rem
  }
  .ledger-table {
  width: 100%;
  border-collapse: collapse;
}

.ledger-table th, .ledger-table td {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: center;
}

.ledger-summary {
  margin-top: 20px;
  text-align: right;
  font-weight: bold;
}
.head{
    display: flex;
    flex-direction: column;
}
.head .title{
    font-size: 20px;
    color: #707070;
}
.head .supplier-name{
    font-size: 25px;
    font-weight: 500;
}
    </style>
  


// WEBPACK FOOTER //
// src/pages/SupplierLedger.vue